import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue';
import {
  getTerms,
  MembershipTermsResponse
} from '@/modules/common/services/http/account';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  BaseText,
  ButtonPrimary,
  ContextColorProvider,
  Heading,
  LoaderIndicator,
  ButtonContainer,
  ContentDisplay
} from '@warrenbrasil/nebraska-web';
import { trackPageView, trackAccepted } from './track-events';
import { Portal } from '@/modules/common/components/Portal';


export default /*#__PURE__*/_defineComponent({
  __name: 'MembershipTermsModal',
  props: {
    isOpen: { type: Boolean }
  },
  emits: ['confirm'],
  setup(__props: any, { emit }) {




const isSubmitting = ref(false);
const loading = ref(false);
const data = ref<MembershipTermsResponse | null>(null);

const setData = async () => {
  loading.value = true;
  data.value = await getTerms();
  loading.value = false;
};

const submit = async () => {
  isSubmitting.value = true;
  trackAccepted();
  emit('confirm', { acceptedTerms: true });
};

onMounted(() => {
  setData();
  trackPageView();
});

return { __sfc: true,emit, isSubmitting, loading, data, setData, submit, NebraskaColors, BaseText, ButtonPrimary, ContextColorProvider, Heading, LoaderIndicator, ButtonContainer, ContentDisplay, Portal }
}

})